module.exports = __webpack_public_path__ + "static/img/globular.58a60c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/globular.png
// module id = WgD2
// module chunks = 215